import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ProfilePage = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState({
    name: '',
    phone: '',
    clientId: ''
  });

  useEffect(() => {
    const fetchUserData = () => {
      const name = localStorage.getItem("name") || '';
      const phone = localStorage.getItem("mobile") || '';
      const clientId = localStorage.getItem("userid") || '';
      
      setUser({ name, phone, clientId });
    };
    
    fetchUserData();
  }, []);

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      localStorage.clear();
      navigate('/login');
    }
  };

  const menuSections = [
    {
      title: 'Account',
      items: [
        {
          icon: 'bi-shield-check',
          title: 'KYC Verification',
          subtitle: 'Complete your KYC to start trading',
          badge: 'Verify Now',
          onClick: () => navigate('/kyc', { state: { userid: user.clientId } }),
          color: 'success'
        },
        {
          icon: 'bi-bank',
          title: 'Bank Details',
          onClick: () => navigate('/bank'),
          color: 'primary'
        },
        {
          icon: 'bi-clock-history',
          title: 'Transaction History',
          onClick: () => navigate('/transaction'),
          color: 'warning'
        }
      ]
    },
    {
      title: 'Support',
      items: [
        {
          icon: 'bi-headset',
          title: 'Customer Support',
          onClick: () => navigate('/contact'),
          color: 'info'
        },
        {
          icon: 'bi-info-circle',
          title: 'About Us',
          onClick: () => navigate('/company'),
          color: 'danger'
        },
        {
          icon: 'bi-box-arrow-right',
          title: 'Logout',
          onClick: handleLogout,
          color: 'secondary',
          isLogout: true
        }
      ]
    }
  ];

  return (
    <div className="bg-light min-vh-100">
      {/* Header */}
      <div className="bg-success text-white p-4">
        <div className="text-center">
          <h5 className="mb-0">PROFILE</h5>
        </div>
      </div>

      {/* Profile Info */}
      <div className="container">
        <div className="text-center mt-n4 mb-4">
          <img 
            src="/assets/user.jpg" 
            alt="Profile"
            className="rounded-circle border border-4 border-white shadow"
            style={{ width: '80px', height: '80px' }}
          />
          <h5 className="mt-3 mb-1 fw-bold">{user.name || 'User Name'}</h5>
          <p className="text-muted mb-2">{user.phone}</p>
          <div className="badge bg-success bg-opacity-10 text-success">
            ID: {user.clientId ? user.clientId.slice(-6) : 'N/A'}
          </div>
        </div>

        {/* Menu Items */}
        {menuSections.map((section, sectionIndex) => (
          <div key={sectionIndex} className="mb-4">
            <h6 className="text-muted mb-3">{section.title}</h6>
            <div className="card shadow-sm">
              <div className="list-group list-group-flush">
                {section.items.map((item, itemIndex) => (
                  <button
                    key={itemIndex}
                    className={`list-group-item list-group-item-action d-flex align-items-center ${
                      item.isLogout ? 'text-danger' : ''
                    }`}
                    onClick={item.onClick}
                  >
                    <div className={`rounded-circle p-2 me-3 bg-${item.color} bg-opacity-10`}>
                      <i className={`bi ${item.icon} text-${item.color}`}></i>
                    </div>
                    <div className="flex-grow-1">
                      <div className="d-flex justify-content-between align-items-center">
                        <span className={item.isLogout ? 'text-danger fw-semibold' : 'fw-semibold'}>
                          {item.title}
                        </span>
                        {item.badge && (
                          <span className={`badge bg-${item.color}`}>{item.badge}</span>
                        )}
                      </div>
                      {item.subtitle && (
                        <small className="text-muted">{item.subtitle}</small>
                      )}
                    </div>
                    {!item.isLogout && (
                      <i className="bi bi-chevron-right text-muted"></i>
                    )}
                  </button>
                ))}
              </div>
            </div>
          </div>
        ))}

        {/* Quick Stats */}
        <div className="card shadow-sm mb-4">
          <div className="card-body">
            <h6 className="text-muted mb-3">Account Status</h6>
            <div className="row text-center">
              <div className="col-4">
                <div className="text-success fw-bold">Active</div>
                <small className="text-muted">Status</small>
              </div>
              <div className="col-4">
                <div className="fw-bold">100%</div>
                <small className="text-muted">Profile</small>
              </div>
              <div className="col-4">
                <div className="fw-bold">0</div>
                <small className="text-muted">Trades</small>
              </div>
            </div>
          </div>
        </div>

        {/* App Info */}
        <div className="text-center text-muted small">
          <p>Capital Easy Trading v1.0</p>
          <p>© 2024 All Rights Reserved</p>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;